import { useAccess, usePendingCount } from "@drs-ops/access/frontend";
import { Badge } from "@drs-ops/ui";
import { Brand, UserMenu } from "@drs-ops/ui/layout";
import { Link } from "@tanstack/react-router";
import { useAuth } from "@/auth";
import { useCanEstimate, useIsAdmin } from "@/auth/useIsAdmin";

export function Header(): React.ReactElement {
  const { logout } = useAuth();
  const me = useAccess().data;
  const isAdmin = useIsAdmin();
  const canEstimate = useCanEstimate();
  const pending = usePendingCount({ enabled: isAdmin });

  return (
    <header className="flex items-center justify-between gap-4 border-b border-border px-4 py-2">
      <div className="flex items-center gap-6">
        <Brand name="DRS Estimator" />
        <nav className="flex items-center gap-3 text-sm">
          <Link to="/" className="[&.active]:font-semibold">
            Home
          </Link>
          {canEstimate && (
            <Link to="/trip-planner" className="[&.active]:font-semibold">
              Trip Planner
            </Link>
          )}
          {isAdmin && (
            <Link to="/settings" className="[&.active]:font-semibold">
              Settings
            </Link>
          )}
          {isAdmin && (
            <Link to="/admin/people" className="flex items-center gap-1 [&.active]:font-semibold">
              People
              {pending ? (
                <Badge variant="secondary" aria-label={`${pending} pending`}>
                  {pending}
                </Badge>
              ) : null}
            </Link>
          )}
        </nav>
      </div>
      {me && (
        <UserMenu
          name={me.user.displayName ?? me.user.email ?? "Signed in"}
          email={me.user.email ?? ""}
          onLogout={() => void logout()}
        />
      )}
    </header>
  );
}
